import React, { useState } from 'react';
import { Card, Form, Switch, Col, Row, Alert } from 'antd';

export interface PatternListConfig {
    showMetadata: boolean;
    showUsageHistory: boolean;
    autoSelectFirst: boolean;
}

const DEFAULT_PATTERN_LIST_CONFIG: PatternListConfig = {
    showMetadata: true,
    showUsageHistory: true,
    autoSelectFirst: true,
};

interface Props {
    initialConfig?: Partial<PatternListConfig>;
    onChange: (config: PatternListConfig) => void;
}

export const SectionConfigPatternList: React.FC<Props> = ({ initialConfig, onChange }) => {
    const [config, setConfig] = useState<PatternListConfig>({
        ...DEFAULT_PATTERN_LIST_CONFIG,
        ...initialConfig,
    });

    const updateField = (field: keyof PatternListConfig, value: any) => {
        const newConfig = { ...config, [field]: value };
        setConfig(newConfig);
        onChange(newConfig);
    };

    return (
        <Card size="small" style={{ background: '#f5f5f5' }}>
            <Alert
                message="Pattern List Configuration"
                description="This section displays patterns used in the selected area with their usage history and measurement point counts."
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
            />
            <Row gutter={12}>
                <Col span={8}>
                    <Form.Item label="Show metadata">
                        <Switch
                            checked={config.showMetadata}
                            onChange={(checked) => updateField('showMetadata', checked)}
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="Show usage history">
                        <Switch
                            checked={config.showUsageHistory}
                            onChange={(checked) => updateField('showUsageHistory', checked)}
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="Auto-select first">
                        <Switch
                            checked={config.autoSelectFirst}
                            onChange={(checked) => updateField('autoSelectFirst', checked)}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};

export default SectionConfigPatternList;
